import React, { useEffect, useState, useCallback } from 'react';
import * as Sentry from "@sentry/react";
import '../_controls.scss';
import './PlayControl.scss';
import PlayIcon from './icons/PlayIcon';
import StopIcon from './icons/StopIcon';

const PlayControl = ({ playerReady }) => {
    const [playing, setPlaying] = useState(false);

    const trackPlayAction = useCallback(() => {
        window.tracker?.click({
            click_type: 'action',
            click_name: 'miniplayer_afspelen',
            chapter_1: 'nederlandfm',
            chapter_2: window.NpoTagContext?.brand
        });
    }, []);

    const trackPauseAction = useCallback(() => {
        window.tracker?.click({
            click_type: 'action',
            click_name: 'miniplayer_pauzeren',
            chapter_1: 'nederlandfm',
            chapter_2: window.NpoTagContext?.brand
        });
    }, []);

    const handlePlay = useCallback(() => {
        trackPlayAction();
        setPlaying(true);
    }, [trackPlayAction]);

    const handlePause = useCallback(() => {
        trackPauseAction();
        setPlaying(false);
    }, [trackPauseAction]);

    const togglePlay = async () => {
        const player = window.NpoPlayer;
        if (!playerReady || !player) return;

        try {
            if (playing) {
                player.pause();
            } else {
                if (player.loadStreamIfNeeded) {
                    await player.loadStreamIfNeeded();
                }
                player.play();
            }
        } catch (error) {
            Sentry.captureException(error);
        }
    };

    useEffect(() => {
        const player = window.NpoPlayer;
        
        if (!playerReady || !player) { 
            return undefined 
        };

        setPlaying(player.isPlaying ?? false);

        player.on('play', handlePlay);
        player.on('pause', handlePause);

        return () => {
            player.off('play', handlePlay);
            player.off('pause', handlePause);
        };
    }, [playerReady, handlePlay, handlePause]);

    return (
        <button
            type="button"
            className="PlayControl clickitem"
            onClick={togglePlay}
            aria-label={playing ? "Stop afspelen" : "Start afspelen"}
            aria-pressed={playing}
        >
            {playing ? <StopIcon /> : <PlayIcon />}
        </button>
    );
};

export default PlayControl;
